import React from 'react';
import { ListItem, ListItemText, Box, Button } from '@mui/material';
import { Settings, SwapHoriz } from '@mui/icons-material';
import type { OrganizationWithRole } from '../api.ts';

type Props = {
  organization: OrganizationWithRole;
  isActive?: boolean;
  canManage?: boolean;
  onSwitch: (org: OrganizationWithRole) => void;
  onManage?: (org: OrganizationWithRole) => void;
};

const OrganizationListItem: React.FC<Props> = ({ organization, isActive, canManage, onSwitch, onManage }) => {
  return (
    <ListItem
      key={organization.id}
      secondaryAction={
        <Box sx={{ display: 'flex', gap: 1 }}>
          {canManage && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<Settings />}
              onClick={() => onManage && onManage(organization)}
            >
              Manage
            </Button>
          )}
          {!isActive && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<SwapHoriz />}
              onClick={() => onSwitch(organization)}
            >
              Switch
            </Button>
          )}
        </Box>
      }
    >
      <ListItemText
        primary={organization.name}
        secondary={`Role: ${organization.role}${isActive ? ' (Active)' : ''}`}
      />
    </ListItem>
  );
};

export default OrganizationListItem;
